import { EventEmitter } from 'events';
import dispatcher from '../dispatcher/dispatcher';


/**
 * Used for notifications, pushes it to this to be picked up by the component
 */
class NotificationStore extends EventEmitter{
    constructor(){
        super();
        this.notification = {};
    }
    addNotification(notificationObj){
        this.notification = notificationObj;
        this.emit("Notifications");
    }
    actionHandler(action){
        switch (action.type) {
            case 'ADD_NOTIFICATION':
                this.addNotification(action.object);
                break;
            default:
                break;
        }
    }
}

const notificationStore = new NotificationStore();
dispatcher.register(notificationStore.actionHandler.bind(notificationStore));

export default notificationStore;


// WEBPACK FOOTER //
// ./src/store/notificationStore.js